import type { GameAction, InputFrame } from "@golazo/shared";
import { vec } from "../core/math.js";
import type { InputSource } from "./keyboard.js";

/**
 * Combina varias fuentes (teclado + táctil). El stick táctil tiene prioridad
 * sobre WASD si ambos mueven a la vez.
 */
export function createCompositeInput(sources: readonly InputSource[]): InputSource {
  const move = vec();

  return {
    consume(): InputFrame {
      const frames = sources.map((s) => s.consume());
      move.x = 0;
      move.y = 0;
      for (const frame of frames) {
        if (frame.move.x !== 0 || frame.move.y !== 0) {
          move.x = frame.move.x;
          move.y = frame.move.y;
          break;
        }
      }

      const held = new Set<GameAction>();
      const pressed = new Set<GameAction>();
      for (const frame of frames) {
        for (const action of frame.held) held.add(action);
        for (const action of frame.pressed) pressed.add(action);
      }

      return { move, held, pressed };
    },
    endTick(): void {
      for (const source of sources) source.endTick();
    },
    dispose(): void {
      for (const source of sources) source.dispose();
    },
  };
}
